import React, { FC } from 'react'
import CareTeamList from './CareTeamList'
import CareTeamDetail from './CareTeamDetail'
import { CareTeamBundle } from '../../../../types/FHIRTypes/Bundle'

type CareTeamsProps = {
  careTeamData: CareTeamBundle;
  careTeamDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const CareTeams: FC<CareTeamsProps> = ({ careTeamData, careTeamDetailId, page, handleChangePage, isFetching, totalPages, currentPage }) => {
  return (
    <div>
      {
        careTeamDetailId && page === 'CareTeam'
          ? (
            <CareTeamDetail
              careTeamDetailId={careTeamDetailId}
            />
          )
          : (
            <CareTeamList
              careTeamData={careTeamData}
              handleChangePage={handleChangePage}
              isFetching={isFetching}
              totalPages={totalPages}
              currentPage={currentPage}
            />
          )
      }
    </div>
  )
}

export default CareTeams